import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'nsf-auth-aside',
  templateUrl: './auth-aside.component.html',
  styleUrl: './auth-aside.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthAsideComponent {

  readonly eyebrow = input<string>('');
  readonly title = input<string>('');
  readonly subtitle = input<string>('');

}